import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	errorKeyDuplicate: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.error-key-duplicate',
		defaultMessage: 'Already exists. Try something else.',
		description: 'validation error displayed if field option is duplicate',
	},
});
